// Mantine
import { Select } from '@mantine/core'
import TableFilterMultiSelect from './TableFilterMultiSelect'

// Component
export default function TableFilter({ filter, tableState, changeFilter }) {
    if (filter.type === 'multiselect') {
        return <TableFilterMultiSelect filter={filter} value={tableState.filters[filter.key] ?? []}
            onChange={(value) => changeFilter(filter.key, value)} />
    }

    if (filter.type === 'select') {
        const filterValue = tableState.filters[filter.key] ?? null

        return (
            <Select
                data={filter.options}
                value={filterValue}
                placeholder={filter.placeholder ?? 'Choisir un élément'}
                label={filter.name}
                searchable
                clearable
                comboboxProps={{ withinPortal: false }}
                onChange={(value) => changeFilter(filter.key, value)}
            />
        )
    }

    if (filter.type === 'boolean') {
        const storedValue = tableState.filters[filter.key]
        const filterValue = storedValue == null ? null : String(storedValue)

        return (
            <Select
                data={filter.options}
                value={filterValue}
                placeholder={filter.placeholder ?? 'Choisir un élément'}
                label={filter.name}
                searchable
                clearable
                comboboxProps={{ withinPortal: false }}
                onChange={(value) => changeFilter(filter.key, value)}
            />
        )
    }

    if (filter.type === 'custom' && filter.component) {
        const FilterComponent = filter.component
        const filterValue = tableState.filters[filter.key] ?? (filter.multiple ? [] : null)

        return (
            <FilterComponent
                value={filterValue}
                onChange={(value) => changeFilter(filter.key, value)}
            />
        )
    }

    return (
        <div>
            <span className="text-sm font-medium">{filter.name}</span>
        </div>
    )
}
